<div *ngIf='advisorSummary.advisorId' class="appointment-card">
    <div class="card-content">
    <div class='name-text'>{{advisorSummary.advisorDisplayName}}</div>
    <div class='details-text'>{{ 'serviceSchedule.slotsBooked' | translate}} - {{advisorSummary.count}}</div>
    <div class='details-text' *ngIf='department === "SERVICE"'>{{ 'serviceSchedule.hoursBooked' | translate}} - {{advisorSummary.totalLaborHour.toFixed(2)}}</div>
</div>
</div>
